import { createAction } from '@reduxjs/toolkit'

const actions = {
  getRemoteDocuments: createAction('REMOTE/DOCUMENTSLIST/FETCH'),
  getRemoteDocumentsSuccess: createAction<Document[]>('REMOTE/DOCUMENTSLIST/SUCCESS'),
  getRemoteDocumentsFail: createAction<Error>('REMOTE/DOCUMENTSLIST/FAIL'),
}

export default actions
